import { Form, Select } from 'antd';
import React from 'react';
import TittleFilter from '../TextFilter';
const SelectStatus: React.FC = () => {
  const { Option } = Select;
  const statusAll = localStorage.getItem(`status${window.location.pathname}`);

  const onChange = (values: any) => {
    localStorage.setItem(`status${window.location.pathname}`, values);
  };

  return (
    <>
      <Form.Item label={<TittleFilter>Status</TittleFilter>} name="status">
        {window.location.pathname === '/dashboard/movimentacoes' ? (
          <Select data-cy="statusMovimentacao" onChange={onChange} defaultValue={!statusAll ? '' : statusAll}>
            <Option value={'CR'}>Cobertura Realizada</Option>
            <Option value={'ANFC'}>Aguardando Nota de Cobertura</Option>
            <Option value={'NC'}>Não necessita cobertura</Option>
          </Select>
        ) : window.location.pathname === '/dashboard/atendimento' ? (
          <Select onChange={onChange} defaultValue={!statusAll ? '' : statusAll}>
            <Option value={'AA'}>Aguardando atendimento</Option>
            <Option value={'EA'}>Em atendimento</Option>
            <Option value={'ARI'}>Aguardando retorno interno</Option>
            <Option value={'ARC'}>Aguardando retorno do cliente</Option>
            <Option value={'AC'}>Atendimento concluído</Option>
          </Select>
        ) : (
          <Select onChange={onChange} defaultValue={!statusAll ? '' : statusAll}>
            <Option value={'SL'}>Solicitado</Option>
            <Option value={'AA'}>Aguardando Agendamento</Option>
            <Option value={'AC'}>Agendamento Crossdock</Option>
            <Option value={'AG'}>Agendado</Option>
            <Option value={'NE'}>Nota Emitida</Option>
            <Option value={'EX'}>Expedido</Option>
          </Select>
        )}
      </Form.Item>
    </>
  );
};

export default SelectStatus;
